// @flow
import Routes from './routes/Routes';

// setup fake backend
import { configureFakeBackend } from './helpers';
import 'react-toastify/dist/ReactToastify.css';
import './assets/scss/Creative.scss';
import { ToastContainer } from 'react-toastify';

// configure fake backend
configureFakeBackend();

type AppProps = {};

const App = (props: AppProps): React$Element<any> => {
    return (
        <>
            <Routes />
            <ToastContainer autoClose={2000} />;
        </>
    );
};

export default App;
